import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import Checkbox from "../Checkbox";

const ShowWelcomePhrasesSwitcher = () => {
    const { i18n } = useTranslation();
    const [checked, setChecked] = useState(false);

    const changeShowWelcomePhrases = (value) => {
        setChecked(value);
        preferencesPhrasesStorage.changeFiltersList('isWelcome', value);
    };

    return (
        <label className="product__deleted-label" key={checked + 'phraseCheckbox'} onClick={(e) => {
            console.log("-----------------------------checked--ShowWelcomePhrasesSwitcher");
            e.preventDefault();
            e.stopPropagation();
            changeShowWelcomePhrases(!checked);
        }}>
            <Checkbox checked={checked} handleChecked={() => {}}/>
            <span className="block__text product__deleted-text">{i18n.t('app.page.preference.showIsWelcome')}</span>
        </label>
    );
};

export default ShowWelcomePhrasesSwitcher;
